import { render, staticRenderFns } from "./ProdutosLista.vue?vue&type=template&id=69415e28&scoped=true&"
import script from "./ProdutosLista.vue?vue&type=script&lang=js&"
export * from "./ProdutosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69415e28",
  null
  
)

export default component.exports